<template>
    <div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @selectChange="selectChange"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test"
            pageID="test">
            <div slot="page-module-btn">
                <el-button type="primary" @click="appointment" v-has="'05010101'">送货预约</el-button>
                <el-button type="primary" @click="amendTheTreaty" v-has="'05010102'">配送改约</el-button>
                <el-button type="primary" @click="warehouseAbnormal" v-has="'05010103'">仓内异常</el-button>
                <el-button type="primary" @click="abnormal" v-has="'05010104'">配送异常</el-button>
                <el-button type="primary" @click="logistics" v-has="'05010105'">菜鸟物流详情</el-button>
            </div>
        </m-pane>
        <el-dialog
            title="送货预约"
            :visible.sync="appointmentVisible"
            width="40%"
            @close="handleAppointmentClose">
                预约送达时间：
                <el-date-picker v-model="appointmentValue" type="datetime" placeholder="选择日期时间" style="margin-right: 20px">
                </el-date-picker>
                备注：
                <el-input v-model="appointmentRemark" placeholder="请输入内容" style="width: 150px;"></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleAppointmentClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleAppointmentChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="配送改约"
            :visible.sync="amendVisible"
            width="40%"
            @close="handleAmendClose">
                客户预约单号：
                <el-input v-model="amendNO" placeholder="请输入内容" style="width: 150px;"></el-input>
                改约送达时间：
                <el-date-picker
                    v-model="amendValue"
                    type="datetime"
                    placeholder="选择日期时间"
                    style="margin-right: 20px">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleAmendClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleAmendChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="仓内异常"
            :visible.sync="warehouseVisible"
            width="30%"
            @close="handleWarehouseClose">
                仓内异常原因:
                <el-select v-model="warehouseReason" placeholder="请选择">
                    <el-option
                        v-for="item in warehouseArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleWarehouseClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleWarehouseChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="配送异常"
            :visible.sync="deliveryVisible"
            width="30%"
            @close="handleDeliveryClose">
                配送异常原因:
                <el-select v-model="deliveryReason" placeholder="请选择">
                    <el-option
                        v-for="item in deliveryArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {this.handleDeliveryClose()}">取 消</el-button>
                    <el-button type="primary" @click="handleDeliveryChange">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="查看菜鸟物流详情"
            :visible.sync="logisticsVisible"
            width="50%"
            @close="() => {
                logisticsVisible = false;
            }">
                <el-table
                :data="logisticsTableData"
                border
                style="width: 100%">
                    <el-table-column
                        prop="taskNo"
                        show-overflow-tooltip
                        label="运输单号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="adOrderNo"
                        show-overflow-tooltip
                        label="AD订单号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="businessType"
                        show-overflow-tooltip
                        label="业务操作类型"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="businessCode"
                        show-overflow-tooltip
                        label="业务编码"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="businessContent"
                        show-overflow-tooltip
                        label="业务内容"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="businessTime"
                        show-overflow-tooltip
                        label="业务时间"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="businessOperator"
                        show-overflow-tooltip
                        label="操作人"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        show-overflow-tooltip
                        label="操作时间"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        show-overflow-tooltip
                        label="备注"
                        width="180">
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="() => {
                        logisticsVisible = false;
                    }">取 消</el-button>
                    <el-button type="primary" @click="() => {
                        logisticsVisible = false;
                        this.$refs.tablePage.$refs.searchList.onSearchChange();
                    }">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import utils from '@/utils/common';
import { maxDay } from '@/modules/transport/tms/common/common';
import config from './config.js';
import {
    getEcommerceList,
    saveWarehouseAbnormal,
    getDictionaryDetailByCode,
    loadElsLogisticsHistory,
    saveTaskReservation,
    saveTaskConversion,
    saveDistributeAbnormal
} from '../../../api/appointment';
import dayjs from 'dayjs';
import { ConstantsTES } from '../../../constans/constans';
import { mapGetters } from 'vuex';
const { getSessionKey } = utils;
const ettaCarrierIssued = 10;
const isCarrier = 'N';
const noDepart = 40; // 未发车
const isSigned = 90; // 已签收
const rejection = 430; // 拒收
export default {
    components: { mPane },
    async mounted() {
        // 提前请求获取数据字典，用于table数据转化
        await this._getDictionaryDetailByCode('SYS_TMS_ELS_WAREHOUSE_REASON').then(res => {
            const arr = res.SYS_TMS_ELS_WAREHOUSE_REASON;
            for (const key in arr) {
                if (arr[key] && key) {
                    this.warehouseArray.push({
                        label: arr[key],
                        value: key
                    });
                }
            }
        });
        await this._getDictionaryDetailByCode('SYS_TMS_DISPATCHING_ABNORMAL').then(res => {
            const arr = res.SYS_TMS_DISPATCHING_ABNORMAL;
            for (const key in arr) {
                if (arr[key] && key) {
                    this.deliveryArray.push({
                        label: arr[key],
                        value: key
                    });
                }
            }
        });
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapGetters(['supplier'])
    },
    data() {
        return {
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            selectArray: [], // 选中的集合
            warehouseVisible: false, // 仓内异常弹窗
            warehouseReason: '', // 仓内异常弹窗选中的值
            warehouseArray: [], // 仓内异常弹窗可选值
            logisticsVisible: false, // 物流详情弹窗
            logisticsTableData: [], // 物流详情table数据
            appointmentVisible: false, // 送货预约弹窗
            appointmentValue: '', // 送货预约弹窗选中的时间
            appointmentRemark: '', // 送货预约弹窗备注
            deliveryVisible: false, // 配送异常弹窗
            deliveryReason: '', // 配送异常弹窗选中的值
            deliveryArray: [], // 配送异常弹窗可选值
            amendVisible: false, // 配送改约弹窗
            amendNO: '', // 配送改约客户预约单号
            amendValue: '' // 配送改约送达时间
        };
    },
    methods: {
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询时，时间跨度不可超过一个月！';
            }
        },
        _getEcommerceList(pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            getEcommerceList({
                pageNo,
                pageSize: this.pageSize,
                ettaCarrierEbcuCode: this.supplier.supplierCode,
                ettaCarrierIssued,
                isCarrier,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const {
                        SYS_TRANSPORT_TASK_STATUS,
                        SYS_SUPPLIER_YES_NO,
                        OMS_TRANS_TYPE,
                        SYS_TMS_DISPATCHING_ABNORMAL
                    } = sessionStorage;
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        item.ettaStatusType = getSessionKey(item.ettaStatus, SYS_TRANSPORT_TASK_STATUS);
                        item.ettaReservationType = getSessionKey(item.ettaReservation, SYS_SUPPLIER_YES_NO);
                        item.ettaDeliveryTypeCodeType = getSessionKey(item.ettaDeliveryTypeCode, OMS_TRANS_TYPE);
                        item.dispatchingAbnormalCodeType = getSessionKey(item.dispatchingAbnormalCode, SYS_TMS_DISPATCHING_ABNORMAL);
                        // 预约异常
                        item.businessCodeType = item.businessCode ? this.warehouseArray.find(i => i.value === item.businessCode).label : '';
                        // 配送异常
                        item.dispatchingAbnormalCodeType = item.dispatchingAbnormalCode ? this.deliveryArray.find(i => i.value === item.dispatchingAbnormalCode).label : '';
                        // 是否供方预约
                        item.etIsSupllyAppointmentType = +item.etIsSupllyAppointment ? '是' : '否';
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        _saveWarehouseAbnormal() {
            saveWarehouseAbnormal({
                ettaIds: this.selectArray.map(item => item.ettaId),
                businessOperator: this.supplier.supplierNameCn,
                warehouseReason: this.warehouseReason
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleWarehouseClose(true);
                    }
                }
            });
        },
        _getDictionaryDetailByCode(key) {
            return getDictionaryDetailByCode({ dictCodes: key }).then(res => {
                if (res && +res.code === 0) {
                    return res.data;
                }
            });
        },
        _loadElsLogisticsHistory(val) {
            loadElsLogisticsHistory({
                taskNo: val.join(',')
            }).then(res => {
                if (res && +res.code === 0) {
                    this.logisticsTableData = res.data.data;
                }
            });
        },
        _saveTaskReservation() {
            saveTaskReservation({
                ettaRemark: this.appointmentRemark,
                ettaReservationTime: dayjs(this.appointmentValue).format('YYYY-MM-DD HH:mm:ss'),
                ettaIds: this.selectArray.map(item => item.ettaId),
                businessOperator: this.supplier.supplierNameCn
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleAppointmentClose(true);
                    }
                }
            });
        },
        _saveTaskConversion() {
            saveTaskConversion({
                ettaReservationNo: this.amendNO,
                ettaReservationTime: dayjs(this.amendValue).format('YYYY-MM-DD HH:mm:ss'),
                ettaIds: this.selectArray.map(item => item.ettaId),
                businessOperator: this.supplier.supplierNameCn
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleAmendClose(true);
                    }
                }
            });
        },
        _saveDistributeAbnormal() {
            saveDistributeAbnormal({
                distributeReason: this.deliveryReason,
                businessOperator: this.supplier.supplierNameCn,
                ettaIds: this.selectArray.map(item => item.ettaId)
            }).then(res => {
                if (res && +res.code === 0) {
                    if (!res.data.success) {
                        this.$message.error(res.data.messagesAsString);
                    } else {
                        this.$message.success('成功!');
                        this.handleDeliveryClose(true);
                    }
                }
            });
        },
        pageChange(val) {
            this.currentPage = val;
            this._getEcommerceList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getEcommerceList();
        },
        // 查询结果
        searchChange(val) {
            val = this.formattingData(val);
            this.searchData = val;
            this._getEcommerceList();
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                ...data
            };
            delete tempData.createTime;
            delete tempData.carTime;
            return tempData;
        },
        selectChange(data) {
            this.selectArray = data;
        },
        // 仓内异常
        warehouseAbnormal() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            if (this.selectArray.length > 1) {
                this.$message.error('只能选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c !== 'ELS') {
                    this.$message.error('运输单' + item.ettaNo + '非ELS单据，不能做仓内异常反馈');
                    return false;
                }
                if (+item.ettaStatus === +ConstantsTES.TASK_STATUS_HANG || +item.ettaStatus === +ConstantsTES.TASK_STATUS_REVOKE) {
                    this.$message.error('运输单' + item.ettaNo + '为冲销或者挂起状态，不能执行仓内异常操作!');
                    return false;
                }
                if (+item.ettaStatus >= +ConstantsTES.TASK_STATUS_LOADING) {
                    this.$message.error('运输单' + item.ettaNo + '已出库，不能执行仓内异常操作!');
                    return false;
                }
                if (item.ettaStatus === 'ELS' && +item.ettaIsAllot === 1 && +item.ettaAllotNo !== 1) {
                    this.$message.error('运输单' + item.ettaNo + '属于分拨非第一段,请进行配送异常操作!');
                    return false;
                }
            }
            this.warehouseVisible = true;
        },
        handleWarehouseClose(req) {
            this.warehouseVisible = false;
            this.warehouseReason = '';
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleWarehouseChange() {
            if (!this.warehouseReason) {
                this.$message.error('请选中原因');
                return false;
            }
            this._saveWarehouseAbnormal();
        },
        // 菜鸟物流详情
        logistics() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            if (this.selectArray.length > 1) {
                this.$message.error('只能选中一条数据');
                return false;
            }
            this._loadElsLogisticsHistory(this.selectArray.map(item => item.ettaNo));
            this.logisticsVisible = true;
        },
        // 送货预约
        appointment() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            const {
                TASK_STATUS_ROWOFCARS,
                TASK_STATUS_NEW,
                TASK_STATUS_SHUNTING,
                TASK_STATUS_THECAR
            } = ConstantsTES;
            for (const item of this.selectArray) {
                if (item.ettaStatus !== TASK_STATUS_NEW &&
                    item.ettaStatus !== TASK_STATUS_ROWOFCARS &&
                    item.ettaStatus !== TASK_STATUS_SHUNTING &&
                    item.ettaStatus !== TASK_STATUS_THECAR) {
                    this.$message.error('存在已发货订单，不能预约。');
                    return false;
                }
                if (item.etta2b2c === 'ELS' && item.ettaIsAllot === '1' && item.ettaAllotNo !== '1') {
                    this.$message.error(`运输单${item.ettaNo}属于分拨非第一段,请进行配送改约操作!`);
                    return false;
                }
            }
            this.appointmentVisible = true;
        },
        handleAppointmentClose(req) {
            this.appointmentVisible = false;
            this.appointmentValue = '';
            this.appointmentRemark = '';
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleAppointmentChange() {
            if (!this.appointmentValue) {
                this.$message.error('请选中时间');
                return false;
            }
            this._saveTaskReservation();
        },
        // 配送改约
        amendTheTreaty() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c !== 'ELS') {
                    this.$message.error('运输单' + item.ettaNo + '非ELS单据，不能做配送预约！');
                    return false;
                }
                if (+item.ettaStatus <= noDepart && +item.ettaIsAllot === 1 && +item.ettaAllotNo !== 1) {
                    this.$message.error('运输单' + item.ettaNo + '尚未发车，先做配送预约，发车后的单据才做改约！');
                    return false;
                }
                if (+item.ettaStatus === isSigned) {
                    this.$message.error('运输单' + item.ettaNo + '已签收状态，不能做改约！');
                    return false;
                }
                if (+item.ettaStatus === rejection) {
                    this.$message.error('运输单' + item.ettaNo + '用户拒收状态，不能做改约！');
                    return false;
                }
            }
            this.amendVisible = true;
        },
        // 配送异常
        abnormal() {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c !== 'ELS') {
                    this.$message.error('运输单' + item.ettaNo + '非ELS单据，不能做配送异常反馈！');
                    return false;
                }
                if (+item.ettaStatus === +ConstantsTES.TASK_STATUS_HANG || +item.ettaStatus === +ConstantsTES.TASK_STATUS_REVOKE) {
                    this.$message.error('运输单' + item.ettaNo + '为冲销或者挂起状态，不能执行配送异常操作!');
                    return false;
                }
                if (+item.ettaStatus <= +ConstantsTES.TASK_STATUS_LOADING) {
                    if (+item.ettaIsAllot === 1 && +item.ettaAllotNo !== 1) {
                        this.$message.error('运输单' + item.ettaNo + '未发车，不能执行配送异常操作!');
                        return false;
                    }
                }
            }
            this.deliveryVisible = true;
        },
        handleDeliveryClose(res) {
            this.deliveryVisible = false;
            this.deliveryReason = '';
            if (res) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleDeliveryChange() {
            if (!this.deliveryReason) {
                this.$message.error('请选中原因');
                return false;
            }
            this._saveDistributeAbnormal();
        },
        handleAmendClose(req) {
            this.amendVisible = false;
            this.amendNO = '';
            this.amendValue = '';
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleAmendChange() {
            if (!this.amendValue) {
                this.$message.error('请选中改约时间!');
                return false;
            }
            this._saveTaskConversion();
        }
    }
};
</script>
<style lang="less">
</style>